"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compose = void 0;
var applyTo_1 = require("./applyTo");
/**
 *
 * Compose takes HOCs and returns a function that combines them from the right to the left
 *
 * @category Function
 * @param {...Function} functions - the functions to compose
 * @returns {Function} the composed function
 *
 * @example
 * const increment = x => 1
 * const double = x => x * 2
 * const doubleAndIncrement = compose(increment, double)
 * doubleAndIncrement(1) //=> 3
 */
var compose = function () {
    var functions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        functions[_i] = arguments[_i];
    }
    return function (value) {
        return functions.reduceRight(applyTo_1.applyTo, value);
    };
};
exports.compose = compose;
